<template>
    <div v-if="notaFiscal">

        <!-- Modal -->
        <div class="modal fade" :id="nomeModalNF2" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-danger">Atenção!</h5>
                        <button type="button" class="close" @click="fechar(nomeModalNF2)" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <div class="alert alert-danger" role="alert">
                                    <h6 class="alert-heading">Cancelamento manual</h6>
                                    <hr>
                                    <template v-if="!notaFiscal.st_codigo_verificacao">
                                        <h5 class="text-wrap" v-if="!exibir_cancelar_manual">A Nota fiscal não possui código de verificação.</h5>
                                        <h5 class="text-wrap">O cancelamento será efetuado somente no sistema. Verifique se é necessário cancelar a Nota no site da prefeitura.</h5>
                                    </template>
                                    <template v-else>
                                        <h5 class="text-wrap">O serviço de emissão de Notas Fiscais não possui cancelamento online.</h5>
                                        <h5 class="text-wrap">A Nota Fiscal deverá ser cancelada manualmente no site da prefeitura.</h5>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="text"
                                    label="Motivo do cancelamento"
                                    placeholder="Motivo do cancelamento..."
                                    :validate="validate"
                                    required
                                    v-model="cancelar_motivo" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar(nomeModalNF2)">Fechar</button>
                        <az-submit @click="cancelar_manual()">Salvar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="expanded"> </template>
        <template v-else>
            <!-- Status da Nota Fiscal -->
            <template v-if="exibirEditar">
                <a
                    v-if="notaFiscal.ch_status == '1'"
                    href="#"
                    @click.prevent="editar()"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Nota Fiscal Gerada"
                    class="text-primary ml-2"
                >
                    <i class="fas fa-pen"></i>
                </a>

                <a
                    v-else-if="notaFiscal.ch_status == '2'"
                    href="#"
                    @click.prevent="editar()"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Nota Fiscal Gerada"
                    class="text-Warning ml-2"
                >
                    <i class="fas fa-pen"></i>
                </a>

                <a
                    v-else-if="notaFiscal.ch_status == '3'"
                    href="#"
                    @click.prevent="editar()"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Nota Fiscal Gerada"
                    class="text-info ml-2"
                >
                    <i class="fas fa-pen"></i>
                </a>

                <a
                    v-else-if="notaFiscal.ch_status == '4'"
                    href="#"
                    @click.prevent="editar()"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Nota Fiscal Gerada"
                    class="text-success ml-2"
                >
                    <i class="fas fa-pen"></i>
                </a>

                <a
                    v-else-if="notaFiscal.ch_status == '5'"
                    href="#"
                    @click.prevent="editar()"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Nota Fiscal Cancelada"
                    class="text-danger ml-2"
                >
                    <i class="fas fa-pen"></i>
                </a>
            </template>

            <!-- Emissão online -->
            <template>
                <span :class="left ? 'dropleft' : 'dropdown'">
                    <a
                        class="btn btn-link py-0"
                        :class="notaFiscal.ch_status == '5' ? 'text-muted' : 'text-success'"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <div class="spinner-grow spinner-grow-sm" role="status" v-if="$store.state.loading">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <i class="fas fa-wifi" data-toggle="tooltip" data-placement="top" title="Emitir Nota Fiscal" v-else></i>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" href="#"
                            :class="(notaFiscal.ch_status == '1' || notaFiscal.ch_status == '2') ? '' : 'disabled'"
                            @click.prevent="emitir_nota_fiscal()"
                            v-if="!$store.state.loading">
                            {{(notaFiscal.ch_status == '1') ? 'Emitir' : 'Tentar novamente'}}
                        </a>
                        <a class="dropdown-item" href="#" @click.prevent="mudar_competencia()" v-if="notaFiscal.dt_competencia && notaFiscal.ch_status == '1'">
                            {{is_mes_atual() ? 'Alterar competência (mês anterior)' : 'Alterar competência (mês atual)'}}
                        </a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="#" @click.prevent="consultar_situacao()">
                            Consultar situação
                        </a>
                        <template v-if="notaFiscal.ch_status != '5'">
                            <a
                                class="dropdown-item"
                                :class="notaFiscal.ch_status != '5' && notaFiscal.ch_status != '1' && notaFiscal.st_codigo_verificacao != '' ? '' : 'disabled'"
                                href="#"
                                @click.prevent="consultar_rps()"
                                >Consultar Chave de Acesso</a>
                            <a
                                class="dropdown-item"
                                :class="( notaFiscal.ch_status == '1' || notaFiscal.ch_status == '3' || (notaFiscal.ch_status == '4' && notaFiscal.st_chave_acesso != '' ) ) ? '' : 'disabled'"
                                href="#"
                                @click.prevent="cancelar_nf()"
                                >Cancelar</a>
                            <a
                                class="dropdown-item"
                                href="#"
                                v-if="notaFiscal.ch_status == '1'
                                    && (notaFiscal.st_codigo_verificacao == '' || notaFiscal.st_codigo_verificacao == null)
                                    && (notaFiscal.st_erro != '' && notaFiscal.st_erro != null)"
                                @click.prevent="informar_protocolo()"
                                >Informar Protocolo Manualmente</a>
                            <a
                                class="dropdown-item"
                                href="#"
                                :class="notaFiscal.ch_status != '4' ||  notaFiscal.st_chave_acesso == '' ? 'disabled' : ''"
                                @click.prevent="enviar_email_nf()"
                                >Enviar Nota Fiscal para o Tomador</a>
                            <a
                                class="dropdown-item"
                                href="#"
                                :class="notaFiscal.ch_status == '1' || notaFiscal.ch_status == '2' || (notaFiscal.ch_status == '4' && notaFiscal.st_chave_acesso != '') ? '' : 'disabled'"
                                @click.prevent="imprimir_nf()"
                                >{{ (notaFiscal.ch_status == '1' || notaFiscal.ch_status == '2') ?  'Imprimir RPS' : 'Imprimir'}}</a>
                            <!-- <a
                                class="dropdown-item"
                                href="#"
                                :class="notaFiscal.ch_status != '4' ||  notaFiscal.st_chave_acesso == '' ? 'disabled' : ''"
                                @click.prevent="imprimir_nf()"
                                >Imprimir</a> -->
                        </template>
                        

                        <a class="dropdown-item" href="#" v-if="exibir_cancelar_manual" @click.prevent="cancelar_manual_admin()">
                            Cancelar Manualmente
                        </a>

                        <div class="dropdown-divider"></div>

                        <a class="dropdown-item" href="#" @click.prevent="ver_descricao()">
                            Descrição
                        </a>

                        <a class="dropdown-item" href="#" @click="abrir_logs_nota_fiscal()">
                            Logs de Comunicação
                        </a>

                        <a class="dropdown-item" href="#"
                            @click.prevent="$util.logAudit('notaFiscalServico', notaFiscal.id_nota_fiscal_servico);">
                            Log
                        </a>
                    </div>
                </span>
            </template>
        </template>

        <!-- Modal de Nota Fiscal -->
        <div
            class="modal fade"
            :id="nomeModalNF"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modelTitleId"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-scrollable modal-xl  modal-dialog-cheio"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Nota Fiscal de Serviço
                        </h5>
                        <button
                            type="button"
                            class="close"
                            @click="fechar(nomeModalNF)"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="!item">
                            <az-empty-state />
                        </div>

                        <div v-else-if="item">

                            <!-- Numero / Emissao / classificação -->
                            <div class="form-row">
                                <div class="col col-12 col-md-3" v-if="$store.state.unidade.unidade_operacaos.length > 1">
                                    <az-input
                                        sizing="sm"
                                        label="Unidade"
                                        type="select"
                                        placeholder="Selecione..."
                                        :optionsList="$store.state.unidade.unidade_operacaos"
                                        optionsData="id_unidade_operacao"
                                        required
                                        :validate="validate"
                                        :edicao="edicao"
                                        v-model="item.id_unidade_operacao"
                                    />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        type="date"
                                        label="Emissão"
                                        :validate="validate"
                                        required
                                        :edicao="edicao"
                                        v-model="item.dt_emissao" />
                                </div>
                                <div class="col col-12 col-md-2">
                                   <az-input
                                        sizing="sm"
                                        label="Número - Serie - Tipo"
                                        :edicao="false"
                                        v-model="item.numero_completo" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        label="Natureza da operação"
                                        optionsData="id"
                                        :edicao="edicao"
                                        :optionsList="[
                                            { id: '1', search: 'Tributação no município'},
                                            { id: '2', search: 'Tributação fora do município'},
                                            { id: '3', search: 'Isenção'},
                                            { id: '4', search: 'Imune'},
                                            { id: '5', search: 'Exigibilidade suspensa por decisão judicial'},
                                            { id: '6', search: 'Exigibilidade'},
                                        ]"
                                        v-model="item.ch_natureza_operacao" />
                                </div>
                                 <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        label="Status"
                                        optionsData="id"
                                        :edicao="edicao"
                                        :optionsList="[
                                            { id: '1', search: 'Gerada'},
                                            { id: '2', search: 'Aguardando processamento'},
                                            { id: '3', search: 'Processado com Erro'},
                                            { id: '4', search: 'Emitida'},
                                            { id: '5', search: 'Cancelada'},
                                        ]"
                                        v-model="item.ch_status" />
                                </div>

                            </div>

                            <!-- Tomador -->
                            <div class="form-row">
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Código Tributação Município"
                                        :edicao="false"
                                        v-model="item.st_codigo_tributacao_municipio" />
                                </div>
                                <div class="col col-12 col-md-5">
                                    <az-input
                                        sizing="sm"
                                        label="Tomador do Serviço"
                                        :edicao="false"
                                        v-model="item.tomador" />
                                </div>
                                <div class="col col-12 col-md-5">
                                    <az-input
                                        sizing="sm"
                                        label="Endereço do Tomador"
                                        :edicao="false"
                                        v-model="item.endereco_completo" />
                                </div>
                            </div>

                            <!-- Impostos -->
                            <div class="form-row">
                                <div class="col col-12 col-md-2">
                                   <az-input
                                        icon="prepend"
                                        label="Valor Serviço"
                                        sizing="sm"
                                        type="money"
                                        :edicao="edicao"
                                        v-model="item.dc_valor_servicos">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                   <az-input
                                        icon="prepend"
                                        label="Base de Cálculo"
                                        sizing="sm"
                                        type="money"
                                        :edicao="edicao"
                                        v-model="item.dc_base_calculo">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                   <az-input
                                        icon="prepend"
                                        label="Valor Deduções"
                                        sizing="sm"
                                        type="money"
                                        :edicao="edicao"
                                        v-model="item.dc_valor_deducoes">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                   <az-input
                                        icon="prepend"
                                        label="Outras Retenções"
                                        sizing="sm"
                                        type="money"
                                        :edicao="edicao"
                                        v-model="item.dc_outras_retencoes">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-1">
                                   <az-input
                                        icon="prepend"
                                        label="PIS"
                                        sizing="sm"
                                        type="money"
                                        :edicao="edicao"
                                        v-model="item.dc_valor_pis">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-1">
                                   <az-input
                                        icon="prepend"
                                        label="COFINS"
                                        sizing="sm"
                                        type="money"
                                        :edicao="edicao"
                                        v-model="item.dc_valor_cofins">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-1">
                                   <az-input
                                        icon="prepend"
                                        label="IRRF"
                                        sizing="sm"
                                        type="money"
                                        :edicao="edicao"
                                        v-model="item.dc_valor_irrf">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-1">
                                   <az-input
                                        icon="prepend"
                                        label="CSLL"
                                        sizing="sm"
                                        type="money"
                                        :edicao="edicao"
                                        v-model="item.dc_valor_csll">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>

                            </div>

                            <!-- VALOR TOTAL e chave de acesso -->
                            <div class="form-row">
                                <div class="col col-12 col-md-2">
                                   <az-input
                                        icon="prepend"
                                        label="Valor Liquido NF"
                                        sizing="sm"
                                        type="money"
                                        :edicao="edicao"
                                        v-model="item.dc_valor_liquido_nfse">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                 <div class="col col-12 col-md-2">
                                   <az-input
                                        icon="prepend"
                                        label="Iss Retido"
                                        sizing="sm"
                                        :edicao="edicao"
                                        v-model="item.reter_iss">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <i class="fas fa-check"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                   <az-input
                                        icon="prepend"
                                        label="Aliquota ISS"
                                        sizing="sm"
                                        type="money"
                                        :edicao="edicao"
                                        v-model="item.dc_aliquota">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <i class="fas fa-percent"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                   <az-input
                                        icon="prepend"
                                        label="ISS"
                                        sizing="sm"
                                        type="money"
                                        :edicao="edicao"
                                        v-model="item.dc_valor_iss">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <!-- chave de acesso -->
                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                   <az-input
                                        label="Código de Verificação"
                                        sizing="sm"
                                        :edicao="edicao"
                                        v-model="item.st_codigo_verificacao">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-6">
                                   <az-input
                                        label="Chave de Acesso"
                                        sizing="sm"
                                        :edicao="edicao"
                                        v-model="item.st_chave_acesso">
                                    </az-input>
                                </div>
                            </div>

                            <!-- Mensagem de erro -->
                            <div class="form-row">
                                <div class="col col-12 col-md-12">
                                    <az-input
                                        sizing="sm"
                                        type="textarea"
                                        rows="2"
                                        label="Último erro na emissão da NF"
                                        :edicao="edicao"
                                        v-model="item.st_erro" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12">
                                   <az-input
                                        label="Discriminação dos Serviços"
                                        type="textarea"
                                        sizing="sm"
                                        rows="5"
                                        :edicao="edicao"
                                        v-model="item.st_discriminacao">
                                    </az-input>
                                </div>
                            </div>

                            <!-- Faturas -->
                            <template v-if="item.link_faturas && item.link_faturas.length">
                                <div class="card mt-3">
                                    <div class="card-header">
                                        Faturas
                                    </div>
                                    <ul class="list-group">
                                        <li class="list-group-item d-flex justify-content-between" v-for="(fatura, ifx) in item.link_faturas" :key="ifx">
                                            <div>#{{ fatura.model_id }}</div>
                                            <div>
                                                <span v-if="fatura.st_info">
                                                    {{ $util.getFormatDate(fatura.st_info) }}
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="modal-footer" v-if="item">
                        <button type="button" class="btn btn-secondary" @click="fechar(nomeModalNF)">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Descrição da Nota Modal -->
        <div class="modal fade" :id="'descr' + nomeModalNF" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Descrição</h5>
                        <button type="button" class="close" @click="fechar('descr' + nomeModalNF)" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="alert alert-info">
                            <div class="lead">
                                {{ item.st_tomador_nome }}
                            </div>
                            <div>
                                {{ item.numero_completo }} 
                            </div>
                            <div v-if="item.dc_valor_servicos">
                                Valor: {{ $util.formatMoeda(item.dc_valor_servicos) }}
                            </div>
                        </div>

                        <az-input
                            type="textarea"
                            label="Descrição da Nota Fiscal"
                            rows="5"
                            required
                            :validate="validate"
                            v-model="item.st_discriminacao" />

                        <az-input
                            type="textarea"
                            label="Outras Informações da Nota Fiscal"
                            rows="5"
                            :validate="validate"
                            v-model="item.st_outras_informacoes" />

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar('descr' + nomeModalNF)">Fechar</button>
                        <az-submit v-if="item && item.ch_status == 1" @click="atualizar_descricao()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Protocolo da Nota Modal -->
        <div class="modal fade" :id="'protocolo' + nomeModalNF3" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Protocolo/Código Verificação</h5>
                        <button type="button" class="close" @click="fechar('protocolo' + nomeModalNF3)" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="alert alert-info">
                            <div class="lead">
                                {{ item.st_tomador_nome }}
                            </div>
                            <div>
                                {{ item.numero_completo }} 
                            </div>
                            <div v-if="item.dc_valor_servicos">
                                Valor: {{ $util.formatMoeda(item.dc_valor_servicos) }}
                            </div>
                        </div>

                        <az-input
                            label="Protocolo da Nota Fiscal"
                            required
                            :vaidate="validate"
                            v-model="item.st_codigo_verificacao" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar('protocolo' + nomeModalNF3)">Fechar</button>
                        <az-submit v-if="item && item.ch_status == 1" @click="atualizar_protocolo()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
        
        <log-nota-fiscal ref="logNotaFiscal" />
    </div>
</template>

<script>
import $ from "jquery";
import _ from 'lodash';
import * as moment from "moment";
// import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from "../../shared/forms/AzInput";
import AzEmptyState from "../../util/AzEmptyState.vue";
import { subscribe, unSubscribe } from "../../../service/Notify";
import AzSubmit from '../../util/AzSubmit.vue';
import LogNotaFiscal from "../../shared/audit/LogNotaFiscal.vue";

export default {
    data() {
        return {
            item: null,
            edicao: false,
            cancelar_motivo: '',
            validate: false,
        };
    },
    props: ["notaFiscal", "exibirEditar", "expanded", "left", "exibir_cancelar_manual"],

    components: {
        // AzSubmit,
        AzInput,
        AzEmptyState,
        AzSubmit,
        LogNotaFiscal
    },

    computed: {
        nomeModalNF: function () {
            return 'nfModal' + this.notaFiscal.id_nota_fiscal_servico;
        },
        nomeModalNF2: function () {
            return 'nfModal2' + this.notaFiscal.id_nota_fiscal_servico;
        },
        nomeModalNF3: function () {
            return 'nfModal3' + this.notaFiscal.id_nota_fiscal_servico;
        }

    },

    methods: {
        atualizar_descricao () {
            this.$util.atualizar(this, {
                service: 'nota_fiscal_servico',
                func: 'alterar_descricao',
                dados: this.item,
                modal: 'descr' + this.nomeModalNF,
                callback: () => {
                    this.$emit('refresh');
                }
            });
        },

        fechar(modal) {
            $('#' + modal).modal('hide');
        },

        ver_descricao () {
            this.validate = false;
            this.item = _.cloneDeep(this.notaFiscal);

            this.$nextTick(() => {
                $('#descr' + this.nomeModalNF).modal("show");
            });
        },

        editar() {
            this.item = _.cloneDeep(this.notaFiscal);

            this.$nextTick(() => {
                $('#' + this.nomeModalNF).modal("show");
            });
        },

        emitir_nota_fiscal() {
             if ( !confirm('Deseja emitir a Nota Fiscal de Serviço?') )
                return;

            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: "emitir_nota_fiscal",
                redir_api: true,
                dados: {
                    id_nota_fiscal_servico: this.notaFiscal
                        .id_nota_fiscal_servico
                },
                callback: () => {
                    this.$emit('refresh');

                    if ( window.redir == 'labs' ) {
                        // this.$emit('integrar');
                    }
                }
            });
        },

        is_mes_atual() {
            if(this.notaFiscal && this.notaFiscal.dt_competencia) {
                const competencia = moment(this.notaFiscal.dt_competencia, "YYYY-MM-DD");
                const hj = moment();

                return competencia.month() == hj.month();
            }

            return true;
        },

        mudar_competencia() {
            if ( !confirm('Deseja realemente alterar a competência?') )
                return;

            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: "mudar_competencia",
                toast: false,
                dados: {
                    id_nota_fiscal_servico: this.notaFiscal
                        .id_nota_fiscal_servico,
                    anterior: this.is_mes_atual()
                },
                callback: (res) => {
                    this.$toast.add({
                        severity: res && res.status_code == 200 ? "success" : "error",
                        summary: "Atenção",
                        detail: res && res.msg ? res.msg : (res && res.status_code == 200 ? "Mês de referência alterado com sucesso" : "Erro ao realizar alteração"),
                        life: 3000
                    });

                    this.$emit('refresh');
                },
                error: () => {
                    this.$emit('refresh');
                }
            });
        },

        consultar_situacao() {
            //  if ( !confirm('Atenção!!! Cancele a Nota Fiscal no site da prefeitura ante de consultar a situação. Deseja consultar a situação da Nota Fiscal de Serviço?') )
            //     return;

            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: "consultar_situacao",
                redir_api: true,
                toast: false,
                dados: {
                    id_nota_fiscal_servico: this.notaFiscal
                        .id_nota_fiscal_servico
                },
                callback: () => {
                    // this.$toast.add({
                    //     severity: res && res.status_code == 200 ? "success" : "error",
                    //     summary: "Atenção",
                    //     detail: res && res.msg ? res.msg : (res && res.status_code == 200 ? "Consulta realizada com sucesso" : "Erro ao realizar consulta"),
                    //     life: 3000
                    // });

                    this.$emit('refresh');
                },
                error: () => {
                    this.$emit('refresh');
                }
            });
        },

        consultar_rps() {
            if ( !confirm('Deseja consultar Chave de Acesso da Nota Fiscal de Serviço?') )
                return;

            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: "consultar_rps",
                redir_api: true,
                toast: false,
                dados: {
                    id_nota_fiscal_servico: this.notaFiscal
                        .id_nota_fiscal_servico
                },
                callback: () => {
                    // this.$toast.add({
                    //     severity: res && res.status_code == 200 ? "success" : "error",
                    //     summary: "Atenção",
                    //     detail: res && res.msg ? res.msg : (res && res.status_code == 200 ? "Consulta realizada com sucesso" : "Erro ao realizar consulta"),
                    //     life: 3000
                    // });

                    this.$emit('refresh');
                },
                error: () => {
                    this.$emit('refresh');
                }
            });
        },

        cancelar_nf() {
            if ( !confirm('Deseja realmente cancelar a Nota Fiscal de Serviço?') )
                return;

            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: "cancelar_nf",
                redir_api: true,
                toast: false,
                dados: {
                    id_nota_fiscal_servico: this.notaFiscal
                        .id_nota_fiscal_servico
                },
                callback: (res) => {
                    if(res && res.cancelar_manual) {
                        this.validate = false;
                        this.$nextTick(() => {
                            $('#' + this.nomeModalNF2).modal('show');
                        });
                    } else {
                        this.$toast.add({
                            severity: res && res.status_code == 200 ? "success" : "error",
                            summary: "Atenção",
                            detail: res && res.msg ? res.msg : (res && res.status_code == 200 ? "Cancelamento realizada com sucesso" : "Erro ao realizar cancelmaneto"),
                            life: 3000
                        });
                        this.$emit('refresh');
                    }
                }
            });
        },

        cancelar_manual_admin() {
            this.validate = false;
            this.$nextTick(() => {
                $('#' + this.nomeModalNF2).modal('show');
            });
        },

        cancelar_manual() {
            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: "cancelar_nf_manual",
                toast: false,
                modal: this.nomeModalNF2,
                dados: {
                    id_nota_fiscal_servico: this.notaFiscal
                        .id_nota_fiscal_servico,
                    motivo: this.cancelar_motivo,
                },
                callback: (res) => {
                    this.$toast.add({
                        severity: res && res.status_code == 200 ? "success" : "error",
                        summary: "Atenção",
                        detail: res && res.msg ? res.msg : (res && res.status_code == 200 ? "Cancelamento realizada com sucesso" : "Erro ao realizar cancelmaneto"),
                        life: 3000
                    });
                    this.$emit('refresh');
                }
            });

        },

        informar_protocolo() {
            this.validate = false;
            this.item = _.cloneDeep(this.notaFiscal);
            this.$nextTick(() => {
                $('#protocolo' + this.nomeModalNF3).modal('show');
            });
        },

        atualizar_protocolo() {
            this.$util.atualizar(this, {
                service: 'nota_fiscal_servico',
                func: 'alterar_protocolo',
                dados: this.item,
                modal: 'protocolo' + this.nomeModalNF3,
                callback: () => {
                    this.$emit('refresh');
                }
            });
        },

        enviar_email_nf() {
            if ( !confirm('Deseja realmente enviar a Nota Fiscal por e-mail para o Tomador?') )
                return;

            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: "enviar_email_nf",
                toast: true,
                dados: {
                    id_nota_fiscal_servico: this.notaFiscal
                        .id_nota_fiscal_servico
                },
                callback: () => {
                    this.$emit('refresh');
                }
            });
        },
        imprimir_nf() {
            if(this.notaFiscal.ch_status == '1' || this.notaFiscal.ch_status == '2') {
                this.$util.print_preview('imprimir/rps/' + this.notaFiscal.id_nota_fiscal_servico);
                return;
            }

            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: "imprimir_nf",
                toast: true,
                dados: {
                    id_nota_fiscal_servico: this.notaFiscal.id_nota_fiscal_servico
                },
                callback: (res) => {
                    if (res && res.url) {
                         window.open(res.url, '_blank').focus();
                    }

                    this.$emit('refresh');
                }
            });
        },

        abrir_logs_nota_fiscal() {
           
            this.$refs.logNotaFiscal.abrir(this.notaFiscal.id_nota_fiscal_servico, true);
        }
    },
    mounted() {
        this.canal = this.$store.state.dominio + '-' + this.notaFiscal.id_nota_fiscal_servico + '-notafiscal-servico';

        subscribe(this.canal, "recarregar-nota", () => {
            this.$emit("refresh");
        });
    },
    beforeDestroy() {
        unSubscribe(this.canal, "recarregar-nota");
    }

};
</script>

<style scoped>
.modal-dialog-cheio {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>